import { render, staticRenderFns } from "./PersonAtivity.vue?vue&type=template&id=a5d1bf60&scoped=true"
import script from "./PersonAtivity.vue?vue&type=script&lang=js"
export * from "./PersonAtivity.vue?vue&type=script&lang=js"
import style0 from "./PersonAtivity.vue?vue&type=style&index=0&id=a5d1bf60&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d1bf60",
  null
  
)

export default component.exports